export interface RequestServiceCodeEntity {

    id: number | null,
    serviceRequestCode: string,
    subServiceRequestCode: string,
    remark: string | null,
    activeInd: string | null,

    [key: string]: string | boolean | number | null | Object | undefined
}

export const EMPTY_REQUEST_SERVICE_CODE_ENTITY: RequestServiceCodeEntity = {
    activeInd: 'Y',
    id: null,
    serviceRequestCode: "",
    subServiceRequestCode: "",
    remark: null
}
